module.exports = __webpack_public_path__ + "static/media/certik-logo.3ee6d8b6.svg";